import { Component } from '@angular/core';
import { Router } from '@angular/router';
import {
  MotifTreeModule,
  MotifIconModule,
  MotifFormsModule,
} from '@ey-xd/ng-motif';
import { LoanApiService } from '../../_services/loan-api.service';
import { DataElementService } from '../../_services/dataElement.service';
import { CommonModule } from '@angular/common';
import { ModalUpdateInstructionComponent } from '../../_shared/modal-update-instruction/modal-update-instruction.component';

@Component({
  selector: 'instruction-details',
  standalone: true,
  imports: [
    MotifTreeModule,
    MotifIconModule,
    MotifFormsModule,
    CommonModule,
    ModalUpdateInstructionComponent,
  ],
  templateUrl: './instruction-details.component.html',
  styleUrl: './instruction-details.component.scss',
})
export class InstructionDetailsComponent {
  response: any;
  toggleSwitch: boolean = false;
  basicRequestParams: any = {};
  versionDetails: any = {};
  stepDetails: any = [];
  _instructName: string = '';
  isModalOpen: boolean = false;
  constructor(
    private router: Router,
    private loanApi: LoanApiService,
    private _dataElementService: DataElementService
  ) {
    this._dataElementService.basicRequestParams$.subscribe((params) => {
      this.basicRequestParams = params;
    });
    this._dataElementService.instructionName$.subscribe((_instructName) => {
      this._instructName = _instructName;
    });
  }

  goToAdmin() {
    this.router.navigate(['/ruleEngine']);
  }
  toggle() {
    const version = this.versionDetails?.Version;
    this.toggleSwitch = !this.toggleSwitch;
    const persisted = localStorage.getItem('instructionToggleStates');
    let toggleStates = persisted ? JSON.parse(persisted) : {};
    toggleStates[version] = this.toggleSwitch;
    localStorage.setItem('instructionToggleStates', JSON.stringify(toggleStates));
    this.loanApi.updateInstructionLatestVersion({
      usecase: 'Loan File Review',
      product: 'Loan',
      sub_product: this.basicRequestParams.sub_product,
      asset_class: this.basicRequestParams.asset_class,
      data_element: this.basicRequestParams.data_element,
      doc_category: this.basicRequestParams.DocumentCategory,
      version: version,
      version_is_latest: this.toggleSwitch
    }).subscribe({
      next: () => {},
      error: (err) => {
        this.toggleSwitch = !this.toggleSwitch;
        toggleStates[version] = this.toggleSwitch;
        localStorage.setItem('instructionToggleStates', JSON.stringify(toggleStates));
      }
    });
  }

  ngOnInit() {
    this.loanApi.getInstructionSteps({ ...this.basicRequestParams }).subscribe({
      next: (res) => {
        this.response = res;
        const { version, instruction_steps } = res?.instruction_step || {};
        this.versionDetails = version;
        this.stepDetails = instruction_steps;
        const persisted = localStorage.getItem('instructionToggleStates');
        if (persisted && version?.Version) {
          const toggleStates = JSON.parse(persisted);
          this.toggleSwitch = toggleStates[version.Version] ?? (version?.isLatest === 'True' || version?.isLatest === true);
        } else {
          this.toggleSwitch = version?.isLatest === 'True' || version?.isLatest === true;
        }
      },
      error: (err) => {
        this.goToAdmin();
      },
    });
    /* Setting Data Element List [] */
   // this._dataElementService.setDataElements([]);
  }
  openModal() {
    this.isModalOpen = true; // Open the modal
  }
}
